import React from "react";
import { Card, Title, Tooltip, Icon } from "@skyportal/ui-kit";
import { useTranslation } from "react-i18next";
import { BucketsTable } from "./tables";

import styles from "./BucketsBlock.module.css";

const BucketsBlock = () => {
  const { t } = useTranslation("storageOverview");
  return (
    <Card
      className={styles.card}
      title={
        <div className={styles.titleContainer}>
          <Title level={5}>{t("table.title")}</Title>
          <Tooltip title={t("table.tooltip")}>
            <div className={styles.tooltipIcon}>
              <Icon icon="info" height={16} color="black" />
            </div>
          </Tooltip>
        </div>
      }
    >
      <div className={styles.tableBlock}>
        <BucketsTable />
      </div>
    </Card>
  );
};

export default BucketsBlock;
